<template>
  <Area style="max-width: 350px;" :value="valueProp" :level="3" data-type="name" @on-change="handleChange" />
</template>
<script>
import { default as Area , getDistrictName } from '../../area'
export default {
  components:{ Area },
  data(){
    return {
      valueProp:''
    }
  },
  props: {
    field: {
      type: String
    },
    value: {
      type: String,
      default: ''
    }
  },
  watch:{
    value(v){
      if(v === null){
        this.valueProp = ''
      }else{
        this.valueProp = v
      }
    }
  },
  methods: {
    handleChange(v) {
      let code = v
      let name = getDistrictName(code)
      this.$emit('change', this.field, code, name)
    }
  }
}

</script>
